import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Box, Text } from "@mantine/core";
import DynamicTable from "./DynamicTable";
import FlaggedDataSkeleton from "../../../../components/Skeletons/FlagDetailsSkeletons/FlaggedDataSkeleton";

const FlaggedDataTable = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const { data: flagDataColumns, isLoading: isLoadingColumns } = useQuery({
    queryKey: ["flagged-data-columns", id],
    enabled: false, // only reads from store
  });

  const { data: flagData, isLoading: isLoadingData } = useQuery({
    queryKey: ["flag-details", id],
    enabled: false, // only reads from store
  });

  const isLoading =
    isLoadingColumns || isLoadingData || !flagDataColumns || !flagData;

  if (isLoading) {
    return <FlaggedDataSkeleton />;
  }

  return (
    <Box m="md">
      <Text fw={700} p="md">
        {t("flagDetails.details.flaggedData")}
      </Text>
      <DynamicTable columns={flagDataColumns} rows={flagData?.flaggedData} />
    </Box>
  );
};

export default FlaggedDataTable;
